







































import { Component, Prop, Vue } from 'vue-property-decorator'
import DialogButtons from '@/components/Dialog/parts/DialogButtons.vue'
import DialogOverlay from '@/components/Dialog/parts/DialogOverlay.vue'
import DialogTitle from '@/components/Dialog/parts/DialogTitle.vue'
import DialogWrapper from '@/components/Dialog/parts/DialogWrapper.vue'
import DialogTextField from '@/components/Dialog/parts/DialogTextField.vue'
import { Util } from '@/_global/utils'
import MenusStore from '@/store/modules/MenusStore'

@Component({
    components: {
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class AddMenuDialog extends Vue {
    @Prop() private menuId!: number
    private originMenu!: CMS.Menu
    private originMenuName: string = ''
    private menuName: string = ''
    private isCopying: boolean = false

    mounted() {
        this.isCopying = false
        this.originMenu = MenusStore.menuById[this.menuId]
        this.originMenuName = this.originMenu.name || ''
    }

    get title(): string {
        return '【 ' + this.originMenuName + ' 】'
    }

    get newMenu(): CMS.Menu {
        this.isCopying = true
        // create時は、id も store_ids も設定されないため、ダミーデータ
        const tmpId: number = Util.getTempId(MenusStore.all)
        return {
            id: tmpId,
            theme_id: this.originMenu.theme_id,
            name: this.menuName,
            store_ids: this.originMenu.store_ids,
        }
    }

    private onChange(value: string): void {
        this.menuName = value
    }

    private onCancel() {
        if (!this.isCopying) {
            this.$emit('cancel')
        }
    }

}
